module.exports = __webpack_public_path__ + "static/assets/58a693621548509c0b4ef3c6951f5fb3.svg";